// InfiniteScroll.js
import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import '../styles/InfiniteScroll.scss';
import CustomCursor from './CustomCursor';

const InfiniteScroll = React.forwardRef((props, ref) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const containerRef = useRef(null);
  const textWrapperRef = useRef(null);
  const [showCursor, setShowCursor] = useState(false);
  const textRefs = useRef([]);

  useEffect(() => {
    const handleResize = () => {
      // Cambiar isTwoColumns según el tamaño del viewport
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const texts = textRefs.current;

    if (texts.length === 2) {
      const totalWidth = texts[0].offsetWidth;

      // Posiciona el segundo texto inmediatamente después del primero
      gsap.set(texts[1], { x: totalWidth });

      // Crea una línea de tiempo para animar ambos textos
      const timeline = gsap.timeline({ repeat: -1, ease: 'none' });
      timeline.to(texts, {
        x: `-=${totalWidth}`,
        duration: (isMobile) ? 30 : 80, // Ajusta la duración para cambiar la velocidad
        ease: 'none',
        modifiers: {
          x: gsap.utils.unitize((x) => parseFloat(x) % totalWidth),
        },
      });
    }

    return () => {
      gsap.killTweensOf(texts);
    };
  }, []);

  const handleCursorClick = () => {
    const phoneNumber = '+525566928386'; // Reemplaza con tu número de WhatsApp
    const message = 'Hola, me gustaría obtener más información.';
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, '_blank');
  };

  const handleMouseEnter = () => setShowCursor(true);
  const handleMouseLeave = () => setShowCursor(false);

  return (
    <div
      className="infinite-scroll-container"
      ref={(el) => {
        containerRef.current = el;
        if (ref) ref.current = el;
      }}
    >
      <CustomCursor onClick={handleCursorClick} isVisible={showCursor} />
      <div className="text-wrapper" ref={textWrapperRef} onClick={handleCursorClick}>
        <span
          className="scroll-text"
          ref={(el) => (textRefs.current[0] = el)}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          Let's work together • Let's work together • Let's work together • Let's
          work together • Let's work together • Let's work together • Let's work
          together • Let's work together
        </span>
        <span
          className="scroll-text"
          ref={(el) => (textRefs.current[1] = el)}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          Let's work together • Let's work together • Let's work together • Let's
          work together • Let's work together • Let's work together • Let's work
          together • Let's work together
        </span>
      </div>
    </div>
  );
});

export default InfiniteScroll;
